import React, { useState, useEffect } from "react";
import * as api from "../../api/index";
import { jwtDecode } from "jwt-decode";
import { IoMdArrowBack } from "react-icons/io";
import { useNavigate } from "react-router-dom";
import { 
  FiUser, FiPhone, FiMapPin, FiLock, FiEye, FiEyeOff, 
  FiCheckCircle, FiEdit, FiInfo, FiLayers, FiImage, FiPlus, FiTrash2 
} from "react-icons/fi";

const lagosLGAs = [
  "All Lagos", "Agege", "Ajeromi-Ifelodun", "Alimosho", "Amuwo-Odofin", "Apapa", "Badagry",
  "Epe", "Eti-Osa", "Ibeju-Lekki", "Ifako-Ijaiye", "Ikeja", "Ikorodu", "Kosofe",
  "Lagos Island", "Lagos Mainland", "Mushin", "Ojo", "Oshodi-Isolo", "Shomolu", "Surulere",
];

const categories = [
  {
    name: "Gadgets & Tech",
    sub: [
      {
        name: "Smartphones & Tablets",
        items: ["iPhones", "Samsung Phones", "Tecno & Infinix Phones", "iPads & Tablets", "Phone Accessories"],
      },
      {
        name: "Accessories for Phones & Table",
        items: ["Power Bank", "Charger & Power Adapters", "Cases", "Power Screens", "Stands & Holder", "Stands & Holders", "Cables", "Blutooth Mono Headsets"],
      },
      {
        name: "Smart Watches",
        items: ["Apple", "Samsung", "Oraimo", "Huawei", "Itel", "Fitbit", "Amazfit"],
      },
      {
        name: "Tablets",
        items: ["Apple", "Samsung", "Atouch", "Amazon", "Xiaomi", "Lenovo", "Modlo"],
      },
      {
        name: "Headphones",
        items: ["Apple", "JBL", "Oriamo", "Sony", "Anker", "Logitech", "Samsung"],
      },
    ],
  },
  {
    name: "Electronics",
    sub: [
      { name: "Laptop & Computers", items: ["Laptop", "Desktop Computer", "Server"] },
      { name: "Video Game Consoles", items: ["Video Game Consoles", "Playstation Console", "Nintendo Console"] },
      { name: "Audio & Music Equipment", items: ["Speaker", "Microphones", "Sound Systems", "Home Theater Systems", "Music Mixer", "Walkie Talkies", "Amplifier"] },
      { name: "Headphones", items: ["Apple", "Samsung", "Atouch", "Amazon", "Xiaomi", "Lenovo", "Modlo"] },
      { name: "Photo & Video Cameras", items: ["Digital Cameras", "Video Cameras", "Drones", "DSLR Cameras", "Action Cameras", "Film Cameras"] },
      { name: "Security & Surveillance", items: ["CCTV Cameras", "IP Cameras", "Digital Video Recorders", "CCTV Kit", "Motion Detectors", "Spy Clock", "Spy Glasses"] },
      { name: "Networking Products", items: ["Router", "Switch", "Modem"] },
      { name: "Printers & Scanners", items: ["Printers & Scanners"] },
      { name: "Computer Monitors", items: ["HP", "DELL", "Samsung", "LG", "Asus", "Acer", "Xiaomi"] },
      { name: "Computer Accessories", items: ["Keyboards", "Adapters", "Mice", "Batteries", "Cables", "Webcams", "Flash Drives"] },
      { name: "Accessories & Supplies for Electronics", items: ["Photo & Video Accessories", "Printers & Scanner Accessories", "Networking Product Accessories", "Audio & Music Accessories", "TV & DVD Accessories", "Security & Surveillance Accessories", "Game Console Accessories"] },
      { name: "Video Games", items: ["Video Games"] },
      { name: "Software", items: ["Software"] },
    ],
  },
  {
    name: "Vehicles & Transport",
    sub: [
      { name: "Cars", items: ["Toyota", "Honda", "Lexus", "Mercedes-Benz", "Other Brands"] },
      { name: "Motorcycles & Scooters", items: ["Power Bikes", "Tricycles", "Scooters"] },
      { name: "Spare Parts & Accessories", items: ["Engine Parts", "Tyres & Wheels", "Electrical Parts", "Interior Accessories", "Exterior Accessories", "Audio Parts"] },
      { name: "Heavy Machinery", items: ["Trucks", "Excavators", "Cranes"] },
      { name: "Boats & Marine", items: ["Boats", "Marine Engines", "Marine Accessories"] },
    ],
  },
  {
    name: "Style & Beauty",
    sub: [
      { name: "Men’s Fashion", items: ["Clothing", "Shoes", "Watches", "Accessories"] },
      { name: "Women’s Fashion", items: ["Dresses", "Shoes", "Handbags", "Jewelry", "Accessories"] },
      { name: "Cosmetics & Skincare", items: ["Makeup", "Skincare", "Fragrances", "Beauty Tools"] },
      { name: "Hair & Beauty Tools", items: ["Hair Dryers", "Straighteners", "Extensions & Wigs"] },
    ],
  },
  {
    name: "Home, Furnishing & Appliances",
    sub: [
      { name: "Furniture", items: ["Sofas", "Beds", "Dining Sets", "Wardrobes", "Tables & Chairs"] },
      { name: "Home Decor", items: ["Curtains & Drapes", "Wall Art", "Clocks", "Rugs & Carpets", "Mirrors"] },
      { name: "Kitchen Appliances", items: ["Blenders", "Microwaves", "Cookers", "Refrigerators", "Electric Kettles"] },
      { name: "Lighting", items: ["Bulbs", "Ceiling Lights", "Lamps", "Outdoor Lighting"] },
      { name: "Home Electronics", items: ["Kitchen Gadgets", "Air Conditioners", "Vacuum Cleaners"] },
    ],
  },
  {
    name: "Leisure & Entertainment",
    sub: [
      { name: "Sports & Fitness Gear", items: ["Gym Equipment", "Bicycles", "Sportwear"] },
      { name: "Musical Instruments", items: ["Guitars", "Keyboards", "Drums", "Speaker", "DJ Equipment"] },
      { name: "Books & Games", items: ["Novels", "Educational Books", "Board Games", "Puzzles"] },
    ],
  },
  {
    name: "Commercial Equipment & Tools",
    sub: [
      { name: "Retail & POS Equipment", items: ["POS Machines", "Barcode Scanners", "Receipt Printers", "Cash Registers", "Weighing Scales", "Display Freezers", "Showcases & Counters"] },
      { name: "Restaurant & Catering Equipment", items: ["Ovens & Cookers", "Refrigerators & Freezers", "Food Warmers", "Blenders & Mixers", "Fryers & Grills", "Baking Equipment", "Restaurant Furniture", "Ice Makers"] },
      { name: "Industrial Tools & Machinery", items: ["Power Tools", "Hand Tools", "Welding Machines", "Compressors", "Generators", "Cutting & Grinding Machines", "Drills & Saws", "Tool Boxes"] },
      { name: "Manufacturing & Production Equipment", items: ["Packaging Machines", "Sealing Machines", "Labelling Machines", "Bottle Filling Machines", "Cutting Machines", "Plastic Recycling Machines", "Printing Machines"] },
      { name: "Office & Business Supplies", items: ["Printers", "Photocopiers", "Stationery", "Desks & Chairs", "Filing Cabinets", "Laminators", "Shredders", "Binding Machines"] },
      { name: "Agricultural & Farm Machinery", items: ["Tractors", "Tillers", "Sprayers", "Feed Mixers", "Milling Machines", "Irrigation Pumps", "Processing Equipment"] },
      { name: "Medical & Laboratory Equipment", items: ["Hospital Beds", "Diagnostic Machines", "Sterilizers", "Laboratory Tools", "Weighing & Measuring Devices", "Blood Pressure Monitors"] },
      { name: "Workshop & Construction Equipment", items: ["Scaffolding", "Ladders", "Concrete Mixers", "Hoists & Cranes", "Work Benches", "Industrial Fans", "Air Compressors"] },
      { name: "Safety & Security Equipment", items: ["Fire Extinguishers", "Smoke Detectors", "Security Cameras", "Access Control Devices", "Protective Helmets", "Reflective Vests"] },
    ],
  },
  {
    name: "Building Materials & Electricals",
    sub: [
      { name: "Building Materials & Supplies", items: ["Cement", "Blocks", "Tiles", "Sand", "Roofing Sheets", "Doors & Frames", "Windows"] },
      { name: "Electrical & Wiring", items: ["Electrical Equipment", "Switches & Sockets", "Circuit Breakers", "Wiring & Conduits", "Lighting Fixtures"] },
      { name: "Tools & Machinery", items: ["Hand Tools", "Power Tools", "Electrical Hand Tools", "Measuring & Testing Tools", "Ladders & Scaffolding"] },
      { name: "Water & Plumbing Systems", items: ["Pipes & Fittings", "Pumps", "Bathroom Fixtures", "Water Tanks"] },
      { name: "Safety & Protective Gear", items: ["Helmets", "Gloves", "Harnesses", "Protective Clothing", "Masks & Eye Protection"] },
      { name: "Solar Energy & Power Systems", items: ["Solar Panels", "Solar Inverters", "Solar Lights", "Deep Cycle Batteries", "Charge Controllers", "Solar Generators", "Solar Accessories (Cables, Connectors, Mounts)", "Complete Solar Systems"] },
      { name: "Other Building & Electrical Items", items: ["Fasteners & Hardware", "Wire Mesh", "Plumbing Parts", "Miscellaneous Supplies"] },
    ],
  },
];

const Editpage = () => {
  const [formData, setFormData] = useState({
    Name: "", Email: "", phone: "", lga: "", address: "", bio: "",
    fields: [], shopImages: [], profileImage: null,
  });
  const [resetpassword, setResetPassword] = useState({ NewPassword: "", ConfirmPassword: "" });
  const [showPassword, setShowPassword] = useState({ NewPassword: false, ConfirmPassword: false });

  const [loadingProfile, setLoadingProfile] = useState(false);
  const [loadingPassword, setLoadingPassword] = useState(false);
  const [profileMessage, setProfileMessage] = useState(null);
  const [passwordMessage, setPasswordMessage] = useState(null);
  const [images, setImages] = useState([]);
  const [selectedFiles, setSelectedFiles] = useState([]);
  const [confirmDelete, setConfirmDelete] = useState(null);
  const [loadingImages, setLoadingImages] = useState(false);
  const [error, setError] = useState(null);
  const [selectedCategory, setSelectedCategory] = useState("");
  const [selectedSub, setSelectedSub] = useState("");
  const [selectedItem, setSelectedItem] = useState("");

  const token = localStorage.getItem("token");
  const decoded = jwtDecode(token);
  const userId = decoded.id || decoded._id;
  const typeofuser = decoded.typeofuser || "";
  const navigate = useNavigate();

  const togglePasswordVisibility = (field) => {
    setShowPassword((prev) => ({ ...prev, [field]: !prev[field] }));
  };

  useEffect(() => {
    const fetchProfile = async () => {
      try {
        setLoadingProfile(true);
        const res = await api.UserProfile(userId);
        setFormData({
          Name: res.data?.Name || "", Email: res.data?.Email || "", phone: res.data?.phone || "",
          lga: res.data?.lga || "", address: res.data?.address || "", bio: res.data?.bio || "",
          fields: res.data?.fields || [], shopImages: res.data?.shopImages || [],
          profileImage: res.data?.profileImage || null,
        });
        setImages(res.data?.shopImages || []);
      } catch (err) {
        setError("⚠️ Failed to fetch profile.");
      } finally {
        setLoadingProfile(false);
      }
    };
    fetchProfile();
  }, [userId]);

  const handleChange = (e) => setFormData(prev => ({ ...prev, [e.target.name]: e.target.value }));
  const handlePasswordChange = (e) => setResetPassword(prev => ({ ...prev, [e.target.name]: e.target.value }));
  const handleImageChange = (e) => setFormData(prev => ({ ...prev, profileImage: e.target.files[0] }));

  const handleFileChange = (e) => {
    const files = Array.from(e.target.files);
    if (files.length > 5) return setError("You can only select up to 5 images at once.");
    if (images.length + files.length > 25) return setError("You can only have up to 25 images total.");
    setSelectedFiles(files);
    setError(null);
  };

  const handleUpload = async () => {
    if (!selectedFiles.length) return setError("Please select images to upload.");
    const uploadData = new FormData();
    selectedFiles.forEach((file) => uploadData.append("shopImages", file));
    uploadData.append("userId", userId);
    uploadData.append("email", formData.Email);

    try {
      setLoadingImages(true);
      const res = await api.addShopImage(uploadData);
      setImages(res.data?.shopImages);
      setSelectedFiles([]);
      navigate(-1);
    } catch (err) {
      setError("Failed to upload images.");
    } finally {
      setLoadingImages(false);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoadingProfile(true); setProfileMessage(null); setError(null);
    try {
      await api.editProfile({ ...formData, id: userId });
      setProfileMessage({ type: "success", text: "Profile updated successfully ✅" });
      navigate(-1);
    } catch (error) {
      const message = error.response?.data?.message || error.message || "Profile update failed.";
      setProfileMessage({ type: "error", text: message });
    } finally { setLoadingProfile(false); }
  };

  const handlePasswordSubmit = async (e) => {
    e.preventDefault();
    setLoadingPassword(true); setPasswordMessage(null); setError(null);
    try {
      await api.resetPasswordinProfile(resetpassword);
      setPasswordMessage({ type: "success", text: "Password updated successfully ✅" });
      navigate(-1);
    } catch (error) {
      const message = error.response?.data?.message || error.message || "Password update failed.";
      setPasswordMessage({ type: "error", text: message });
    } finally { setLoadingPassword(false); }
  };

  const handleDelete = async () => {
    if (!confirmDelete) return;
    try { 
      setLoadingImages(true); 
      const res = await api.deleteShopImage(userId, confirmDelete); 
      setImages(res.data?.shopImages); 
      setConfirmDelete(null); 
    } catch (err) { 
      setError("Failed to delete image."); 
    } finally { 
      setLoadingImages(false); 
    }
  };

  const handleRemoveField = (index) => setFormData(prev => ({ ...prev, fields: prev.fields.filter((_, i) => i !== index) }));

  return (
    <div className="min-h-screen bg-gray-50 pb-20">
      {/* 🔝 Sticky Header */}
      <div className="sticky top-0 z-20 bg-white/80 backdrop-blur-md border-b px-4 py-4 flex justify-between items-center shadow-sm">
        <button onClick={() => navigate(-1)} className="p-2 hover:bg-gray-100 rounded-full transition flex items-center gap-1 text-gray-700">
          <IoMdArrowBack size={24} />
          <span className="hidden sm:inline font-bold">Back</span>
        </button>
        <h1 className="text-lg font-black text-gray-900 tracking-tight">Edit Profile</h1>
        <button
          onClick={handleSubmit}
          disabled={loadingProfile}
          className={`px-5 py-2 rounded-xl font-bold text-sm transition-all active:scale-95 shadow-lg ${
            loadingProfile ? "bg-gray-300 text-gray-500 cursor-not-allowed" : "bg-orange-600 text-white shadow-orange-100 hover:bg-orange-700"
          }`}
        >
          {loadingProfile ? "Saving..." : "Save"}
        </button>
      </div>

      <div className="max-w-xl mx-auto p-4 sm:p-6 space-y-8">
        {/* Profile Card */}
        <div className="bg-white shadow-xl shadow-gray-200/50 rounded-[2.5rem] p-6 sm:p-10 border border-gray-100">
          {error && <div className="p-4 mb-6 rounded-2xl bg-red-50 text-red-700 text-xs font-bold border border-red-100">{error}</div>}
          {profileMessage && (
            <div className={`p-4 mb-6 rounded-2xl text-xs font-bold flex items-center gap-2 ${profileMessage.type === "success" ? "bg-green-50 text-green-700 border border-green-100" : "bg-red-50 text-red-700 border border-red-100"}`}>
              <FiCheckCircle /> {profileMessage.text}
            </div>
          )}

          <div className="space-y-8">
            {/* Profile Image */}
            <div className="flex flex-col items-center">
              <label htmlFor="profileImageUpload" className="relative group cursor-pointer">
                <div className="w-32 h-32 rounded-[2.5rem] border-4 border-white shadow-xl overflow-hidden bg-gray-100 transition-transform group-hover:scale-105">
                  {formData.profileImage ? (
                    <img src={typeof formData.profileImage === "string" ? formData.profileImage : URL.createObjectURL(formData.profileImage)} alt="Profile" className="w-full h-full object-cover" />
                  ) : (
                    <div className="flex flex-col items-center justify-center h-full text-gray-400">
                      <FiUser size={40} className="opacity-20" />
                    </div>
                  )}
                  <div className="absolute inset-0 bg-black/40 opacity-0 group-hover:opacity-100 transition flex items-center justify-center">
                    <FiEdit className="text-white text-3xl" />
                  </div>
                </div>
                <div className="absolute -bottom-2 -right-2 bg-orange-600 text-white p-2 rounded-xl shadow-lg border-2 border-white">
                  <FiPlus size={14} />
                </div>
              </label>
              <input id="profileImageUpload" type="file" accept="image/*" onChange={handleImageChange} className="hidden" />
              <p className="text-[10px] font-black text-gray-400 uppercase tracking-widest mt-4">Profile Photo</p>
            </div>

            {/* Basic Info Inputs */}
            <div className="space-y-4">
              {[
                { name: "Name", label: "Full Name", icon: <FiUser />, type: "text" },
                { name: "phone", label: "Phone Number", icon: <FiPhone />, type: "tel" },
                { name: "address", label: "Address", icon: <FiMapPin />, type: "text" },
              ].map((f) => (
                <div key={f.name} className="bg-gray-50 p-4 rounded-3xl border border-gray-100 focus-within:border-orange-500 transition-all">
                  <label className="text-[10px] font-black text-gray-400 uppercase tracking-widest mb-1 block">{f.label}</label>
                  <div className="flex items-center gap-3">
                    <span className="text-gray-400">{f.icon}</span>
                    <input type={f.type} name={f.name} value={formData[f.name]} onChange={handleChange} className="bg-transparent w-full text-gray-800 font-bold focus:outline-none" placeholder={`Enter ${f.label.toLowerCase()}`} />
                  </div>
                </div>
              ))}

              <div className="bg-gray-50 p-4 rounded-3xl border border-gray-100 focus-within:border-orange-500 transition-all">
                <label className="text-[10px] font-black text-gray-400 uppercase tracking-widest mb-1 block">Local Government Area</label>
                <div className="flex items-center gap-3">
                  <FiMapPin className="text-gray-400" />
                  <select name="lga" value={formData.lga} onChange={handleChange} className="bg-transparent w-full text-gray-800 font-bold focus:outline-none appearance-none">
                    <option value="">Select LGA</option>
                    {lagosLGAs.map((lga, i) => <option key={i} value={lga}>{lga}</option>)}
                  </select>
                </div>
              </div>

              <div className="bg-gray-50 p-4 rounded-3xl border border-gray-100 focus-within:border-orange-500 transition-all">
                <label className="text-[10px] font-black text-gray-400 uppercase tracking-widest mb-1 block">Bio / Business Description</label>
                <div className="flex items-start gap-3 mt-1">
                  <FiInfo className="text-gray-400 mt-1" />
                  <textarea name="bio" value={formData.bio} onChange={handleChange} className="bg-transparent w-full text-gray-800 font-bold focus:outline-none h-24 resize-none" placeholder="Tell us about your business" />
                </div>
              </div>
            </div>

            {/* Seller Fields Section */}
            {typeofuser === "Seller" && (
              <div className="pt-4 border-t border-gray-100">
                <h3 className="text-sm font-black text-gray-900 uppercase tracking-tighter mb-4 flex items-center gap-2">
                  <FiLayers className="text-orange-600" /> Business Categories (Max 5)
                </h3>
                
                <div className="flex flex-wrap gap-2 mb-6">
                  {formData.fields.length > 0 ? (
                    formData.fields.map((field, idx) => (
                      <span key={idx} className="bg-orange-50 text-orange-700 px-4 py-2 rounded-2xl text-xs font-black flex items-center gap-2 border border-orange-100">
                        {field}
                        <button type="button" onClick={() => handleRemoveField(idx)} className="text-red-500 hover:text-red-700 transition">
                          <FiTrash2 size={14} />
                        </button>
                      </span>
                    ))
                  ) : (
                    <p className="text-xs text-gray-400 font-bold">No categories selected.</p>
                  )}
                </div>

                <div className="space-y-3">
                  <select value={selectedCategory} onChange={(e) => { setSelectedCategory(e.target.value); setSelectedSub(""); setSelectedItem(""); }} className="w-full bg-gray-50 border border-gray-100 rounded-2xl px-4 py-3 text-sm font-bold focus:outline-none">
                    <option value="">Select Category</option>
                    {categories.map((c) => <option key={c.name} value={c.name}>{c.name}</option>)}
                  </select>

                  {selectedCategory && (
                    <select value={selectedSub} onChange={(e) => { setSelectedSub(e.target.value); setSelectedItem(""); }} className="w-full bg-gray-50 border border-gray-100 rounded-2xl px-4 py-3 text-sm font-bold focus:outline-none">
                      <option value="">Select Subcategory</option>
                      {categories.find((c) => c.name === selectedCategory)?.sub.map((s) => <option key={s.name} value={s.name}>{s.name}</option>)}
                    </select>
                  )}

                  {selectedSub && (
                    <select value={selectedItem} onChange={(e) => setSelectedItem(e.target.value)} className="w-full bg-gray-50 border border-gray-100 rounded-2xl px-4 py-3 text-sm font-bold focus:outline-none">
                      <option value="">Select Item</option>
                      {categories.find((c) => c.name === selectedCategory)?.sub.find((s) => s.name === selectedSub)?.items.map((item) => <option key={item} value={item}>{item}</option>)}
                    </select>
                  )}

                  <button
                    type="button"
                    onClick={() => {
                      if (!selectedCategory || !selectedSub || !selectedItem) return setError("Please select all fields.");
                      if (formData.fields.includes(selectedItem)) return setError("This field is already added.");
                      if (formData.fields.length >= 5) return setError("You can only add up to 5 fields.");
                      setFormData((prev) => ({ ...prev, fields: [...prev.fields, selectedItem] }));
                      setSelectedCategory(""); setSelectedSub(""); setSelectedItem(""); setError(null);
                    }}
                    disabled={!selectedCategory || !selectedSub || !selectedItem}
                    className="w-full py-3 bg-green-600 text-white rounded-2xl font-black text-sm transition-all hover:bg-green-700 disabled:opacity-30 active:scale-95"
                  >
                    Add Business Tag
                  </button>
                </div>
              </div>
            )}
          </div>
        </div>

        {/* Gallery Section */}
        <div className="bg-white shadow-xl shadow-gray-200/50 rounded-[2.5rem] p-6 sm:p-10 border border-gray-100">
          <h2 className="text-lg font-black text-gray-900 mb-2 flex items-center gap-2">
            <FiImage className="text-orange-600" /> Gallery Images
          </h2>
          <p className="text-[10px] font-black text-gray-400 uppercase tracking-widest mb-6">Max 25 images total</p>

          <div className="grid grid-cols-3 sm:grid-cols-4 gap-3 mb-8">
            {images.map((img, idx) => (
              <div key={idx} className="relative group aspect-square rounded-2xl overflow-hidden border border-gray-100 bg-gray-50">
                <img src={img} alt="Gallery" className="w-full h-full object-cover" />
                <button onClick={() => setConfirmDelete(img)} className="absolute top-1 right-1 bg-red-600 text-white p-1.5 rounded-lg opacity-0 group-hover:opacity-100 transition shadow-lg">
                  <FiTrash2 size={14} />
                </button>
              </div>
            ))}
          </div>

          <label htmlFor="galleryUpload" className="w-full h-32 border-2 border-dashed border-gray-200 rounded-[2rem] flex flex-col items-center justify-center cursor-pointer hover:bg-gray-50 hover:border-orange-300 transition-all mb-4">
            <FiPlus className="text-gray-300 text-3xl mb-1" />
            <p className="text-xs font-black text-gray-500 tracking-tight">Tap to add images</p>
            <p className="text-[10px] text-gray-400 font-bold mt-1">Select up to 5 at once</p>
          </label>
          <input id="galleryUpload" type="file" accept="image/*" multiple onChange={handleFileChange} className="hidden" />

          <button
            onClick={handleUpload}
            disabled={loadingImages || !selectedFiles.length}
            className={`w-full py-4 rounded-2xl font-black text-sm transition-all shadow-lg active:scale-95 ${
              loadingImages ? "bg-gray-300 text-gray-500" : "bg-green-600 text-white shadow-green-100 hover:bg-green-700 disabled:opacity-30"
            }`}
          >
            {loadingImages ? "Syncing Images..." : `Upload ${selectedFiles.length || ""} Selection`}
          </button>
        </div>

        {/* Password Reset Section */}
        <div className="bg-white shadow-xl shadow-gray-200/50 rounded-[2.5rem] p-6 sm:p-10 border border-gray-100">
          <h2 className="text-lg font-black text-gray-900 mb-6 flex items-center gap-2">
            <FiLock className="text-red-500" /> Reset Password
          </h2>
          {passwordMessage && (
            <div className={`p-4 mb-6 rounded-2xl text-xs font-bold ${passwordMessage.type === "success" ? "bg-green-50 text-green-700" : "bg-red-50 text-red-700"}`}>
              {passwordMessage.text}
            </div>
          )}
          <div className="space-y-4">
            {["NewPassword", "ConfirmPassword"].map((field) => (
              <div key={field} className="bg-gray-50 p-4 rounded-3xl border border-gray-100 relative focus-within:border-red-500 transition-all">
                <label className="text-[10px] font-black text-gray-400 uppercase tracking-widest mb-1 block">
                  {field === "NewPassword" ? "New Password" : "Confirm Password"}
                </label>
                <div className="flex items-center">
                  <input
                    type={showPassword[field] ? "text" : "password"}
                    name={field}
                    value={resetpassword[field]}
                    onChange={handlePasswordChange}
                    className="bg-transparent w-full text-gray-800 font-bold focus:outline-none pr-10"
                    placeholder="••••••••"
                  />
                  <button type="button" onClick={() => togglePasswordVisibility(field)} className="absolute right-5 text-gray-400 hover:text-gray-600">
                    {showPassword[field] ? <FiEyeOff size={18} /> : <FiEye size={18} />}
                  </button>
                </div>
              </div>
            ))}
            <button
              onClick={handlePasswordSubmit}
              disabled={loadingPassword}
              className={`w-full py-4 rounded-2xl font-black text-sm transition-all shadow-lg active:scale-95 ${
                loadingPassword ? "bg-gray-300 text-gray-500" : "bg-red-600 text-white shadow-red-100 hover:bg-red-700"
              }`}
            >
              {loadingPassword ? "Resetting..." : "Update Password"}
            </button>
          </div>
        </div>
      </div>

      {/* Delete Confirmation Modal */}
      {confirmDelete && (
        <div className="fixed inset-0 z-[100] flex items-center justify-center bg-black/60 backdrop-blur-sm p-4">
          <div className="bg-white p-8 rounded-[2.5rem] shadow-2xl w-full max-w-sm text-center border border-gray-100">
            <div className="w-16 h-16 bg-red-50 text-red-500 rounded-full flex items-center justify-center mx-auto mb-4">
              <FiTrash2 size={24} />
            </div>
            <h3 className="text-lg font-black text-gray-900 mb-2">Delete Photo?</h3>
            <p className="text-gray-500 text-xs font-bold mb-8">This action cannot be undone. It will be removed from your gallery immediately.</p>
            <div className="grid grid-cols-2 gap-3">
              <button onClick={() => setConfirmDelete(null)} className="px-4 py-3 bg-gray-100 text-gray-700 rounded-2xl font-black text-sm transition-all hover:bg-gray-200">Cancel</button>
              <button onClick={handleDelete} className="px-4 py-3 bg-red-600 text-white rounded-2xl font-black text-sm transition-all hover:bg-red-700 shadow-lg shadow-red-100">Yes, Delete</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Editpage;
